// MenuContext.js
import React, { createContext, useState } from "react";

const UserContext = createContext();

const UserProvider = ({ children }) => {
  const [businessID, setBusinessID] = useState();
  const [businessName, setBusinessName] = useState();
  const [businessCircle, setBusinessCircle] = useState();
  const [businessCircles, setBusinessCircles] = useState();
  const [uniqueIdentifier, setUniqueIdentifier] = useState();
  const [name, setName] = useState();
  const [lastName, setLastName] = useState();
  const [userId, setUserId] = useState();
  const [profileId, setProfileId] = useState();
  const [userType, setUserType] = useState();
  const [realLegal, setRealLegal] = useState();
  const [username, setUsername] = useState();
  const [isLoggedin, setIsLoggedin] = useState();
  const [subscription , setSubscription] = useState()

  const [national, setNational] = useState();
  const [thumbnail, setThumbnail] = useState();
  const [thumbnailUrl, setThumbnailUrl] = useState();

  const [wSO2Token, setWSO2Token] = useState();



  const clearAll = ()=>{
    setBusinessID(null);
    setBusinessName(null);
    setBusinessCircle(null);
    setBusinessCircles(null);
    setUniqueIdentifier(null);
    setName(null);
    setLastName(null);
    setUserId(null);
    setProfileId(null);
    setUserType(null);
    setRealLegal(null);
    setUsername(null);
    setIsLoggedin(false);
    setNational(false);
    setThumbnail(false);
    setThumbnailUrl(false);
    setWSO2Token(null);
    setSubscription(null)

  }

  return (
    <UserContext.Provider
      value={{
        businessID,
        setBusinessID,
        businessName,
        setBusinessName,
        setBusinessCircle,
        businessCircle,
        setBusinessCircles,
        businessCircles,
        uniqueIdentifier,
        setUniqueIdentifier,
        name,
        setName,
        lastName,
        setLastName,
        userId,
        setUserId,
        profileId,
        setProfileId,
        userType,
        setUserType,
        realLegal,
        setRealLegal,
        username,
        setUsername,
        isLoggedin, 
        setIsLoggedin,
        national,
        setNational,
        thumbnail,
        setThumbnail,
        thumbnailUrl,
        setThumbnailUrl,
        wSO2Token, 
        setWSO2Token,
        subscription,
        setSubscription,
        clearAll
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export { UserContext, UserProvider };
